import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { waLink } from "../config";

const EASE = [0.16, 1, 0.3, 1];
const reveal = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
  transition: { duration: 0.7, ease: EASE },
};

const FAQS = [
  {
    q: "A consultoria é indicada para iniciantes?",
    a: "Sim! O protocolo é feito 100% sob medida para o seu nível atual, seja você um iniciante absoluto ou um praticante avançado.",
  },
  {
    q: "Como recebo meu treino e minha dieta?",
    a: "Você recebe tudo pelo app da Prime Coaching — treino, dieta, protocolos e avaliações, com vídeos de execução de cada exercício. O acesso é liberado em até 48 horas após a anamnese.",
  },
  {
    q: "E se eu não gostar de algum alimento da dieta?",
    a: "Fornecemos uma tabela de substituições inteligentes com equivalência de macronutrientes para você adaptar suas refeições do dia a dia.",
  },
  {
    q: "Como funciona o suporte pelo WhatsApp?",
    a: "Você tem um canal direto comigo para enviar vídeos de execução, tirar dúvidas sobre refeições fora da rotina e ajustar seu protocolo.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="section-pad border-t border-white/10">
      <div className="container-x grid gap-12 lg:grid-cols-12">
        <motion.div {...reveal} className="lg:col-span-5">
          <p className="overline-label">FAQ</p>
          <h2 className="h2-display mt-4 text-white">
            Perguntas
            <br />
            frequentes.
          </h2>
          <p className="mt-6 max-w-xs text-sm leading-relaxed text-white/55 md:text-base">
            Ficou alguma dúvida? Fale direto comigo — respondo em
            até 24 horas.
          </p>
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="faq-whatsapp-button"
            className="btn-outline mt-8"
          >
            Tirar dúvidas no WhatsApp
          </a>
        </motion.div>

        <motion.div {...reveal} className="lg:col-span-7">
          <Accordion type="single" collapsible className="border-t border-white/10">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-white/10"
              >
                <AccordionTrigger className="py-6 text-left font-display text-xl font-bold uppercase tracking-tight text-white hover:no-underline hover:text-white/70 md:text-2xl">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-sm leading-relaxed text-white/60 md:text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
